import React from 'react';
import ReactImageFallback from 'react-image-fallback';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const defaultImage =
    'data:image/svg+xml;utf8,<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="grin-alt" class="svg-inline--fa fa-grin-alt fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path fill="rgb(108, 117, 125)" d="M200.3 248c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zm128 0c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3z"></path></svg>';

export function SafetyImage(props) {
    const { src, lazyLoad, ...otherProps } = props;
    return lazyLoad ? (
        <LazyLoadImage
            {...otherProps}
            src={src || defaultImage}
            threshold={300}
            placeholder={<img {...otherProps} src={defaultImage} />}
            onError={(e) => (e.target.src = defaultImage)}
        />
    ) : (
        <ReactImageFallback {...otherProps} src={src} fallbackImage={defaultImage} initialImage={defaultImage} />
    );
    //return <ReactImageFallback {...otherProps} src={src} fallbackImage={defaultImage} initialImage={defaultImage} />;
}
